<template>
    <MainPage pageTitle="แจ้งเคลมนัดหมาย" bgClass="bg-white">
        <div class="map-area rounded-t-10">
            <div class="absolute w-full h-full top-0 left-0 flex items-center justify-center rounded-t-10">
                กำลังเตรียมแผนที่...
            </div>
            <div class="absolute w-full h-full top-0 left-0 rounded-t-10" ref="elemMaps"></div>
        </div>
        <div class="px-6 py-4">
            <template v-if="isPageLoaded">
                <ClaimInfo :policyDetail="policyDetail" :datetime="currentTime" />
            </template>
        </div>
        <div class="px-6 py-4">
            <template v-if="isPageLoaded">
                <AppointmentClaimForm :customer="customerInfo" :isDisable="isDisable" @onSubmit="onSubmitForm($event)" />
            </template>
        </div>
    </MainPage>
</template>

<script>
import { defineComponent, inject, onMounted, ref, shallowRef, triggerRef } from 'vue';
import ConfigManager from '@/config/ConfigManager';
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import MapsService from '@/module/Maps/service/MapsService';
import { useRoute } from 'vue-router';
import ClaimService from '../service/ClaimService';
import { DateTime } from 'luxon';
import useAlertModal from '@/helper/composable/modal/useAlertModal';
import { useTracking } from "@/feature/TrackingFeature";


// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
// import ClaimInfo from '../component/ClaimInfo.vue';
import AppointmentClaimForm from '../component/AppointmentClaimForm.vue';

// assets
import IconMapPinNormal from "@/assets/icon/ic-pin-location-solid.svg"

export default defineComponent({
    components: {
        MainPage,
        // ClaimInfo,
        AppointmentClaimForm
    },
    setup: function () {
        const route = useRoute()
        let googleKey = ConfigManager.getGoogleMapsKey();
        const { localeCode } = inject("LocaleStore")
        const modalStore = inject("ModalStore");
        const modalController = modalStore.methods.getModalController()
        const { loadingModal } = useLoadingModal(modalStore);
        const { alertModal } = useAlertModal(modalStore)
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        // const { pdpaModal } = usePdpaModal(modalStore)
        const elemMaps = ref(null)
        const mapService = MapsService(elemMaps, {
            apiKey: googleKey,
            version: "weekly",
            libraries: ["places"]
        }, {
            zoom: 15
        })

        const isPageLoaded = ref(false)
        const policyDetail = shallowRef()
        const customerInfo = shallowRef()
        const currentTime = ref(DateTime.now())
        const placeAddress = ref('')
        const isDisable = ref(true)
        // console.log(localeCode.value)
        if (localeCode.value == 1054) {
            currentTime.value = currentTime.value.reconfigure({ outputCalendar: "buddhist", locale: "th" })
        }

        const getInfo = function () {
            return Promise.all([ClaimService.apiGetPolicyDetail(route.params.policyNo), ClaimService.apiGetCustomerInfo()]).then((resp) => {
                console.log(resp)
                policyDetail.value = resp[0]
                customerInfo.value = resp[1]

                triggerRef(policyDetail) // trigger valeu change
                triggerRef(customerInfo)
            })
        }

        const updatePlaceOccurence = async function () {
            let markerPosition = mapService.pinMarker.value.getPosition()
            return mapService.getAddressByGeolocation({
                lat: markerPosition.lat(),
                lng: markerPosition.lng()
            }).then((addr) => {
                console.log(addr)
                placeAddress.value = addr
            }).catch((err) => {
                console.log(err)
                placeAddress.value = ""
            })
        }

        /**
         *
         * @param {import("../model/AppointmentClaimModel").AppointmentClaimModel} model
         */
        const onSubmitForm = async function (model) {
            tracking.screenName('appointment_claim_motor')
            tracking.event("appointment_claim_motor_page", "click_appointment_claim_motor", "", "");

            loadingModal.show()
            // get place info
            await updatePlaceOccurence()

            let params = model.setGeolocation(mapService.latLng.value)
                .setCarRegistrationNo(policyDetail.value.policy_desc[1].detail)
                .setPlaceInfo(placeAddress.value)
                .getParams()
            // console.log(params)
            ClaimService.apiAppointmentClaim(route.params.policyNo, params).then((res) => {
                console.log(res)
                let acdNo = res.message
                ClaimService.apiSendMsgClaimSuccess(acdNo)
                modalController.appointmentSuccessModal.clearModal().show(acdNo)
                modalController.appointmentSuccessModal.onClickClose(() => {
                    // do nothing
                })
            }).catch(() => {
                alertModal.clearModal().setTitle("ขออภัย").setMsg("ท่านไม่สามารถแจ้งเคลมนัดหมายได้ในขณะนี้").setBtnOk("ปิด").show()
                // showApiErrorModal("ขออภัย", {  })
            }).finally(() => {
                loadingModal.hide()
            })
        }

        const getCurrentLatLng = function () {
            let markerPosition = mapService.pinMarker.value.getPosition()
            if (markerPosition == null) {
                return {
                    lat: null,
                    lng: null
                }
            }

            return {
                lat: markerPosition.lat(),
                lng: markerPosition.lng()
            }
        }

        const updateMap = function () {
            isDisable.value = false
        }

        const locationUpdated = function () {
            // Add event listener to pin marker dragend event
            mapService.pinMarker.value.addListener('dragend', () => {
                const latlng = getCurrentLatLng();
                console.log('Pin location updated:', latlng);
                updateMap()
                // Do something with the updated location
            });
        }

        const alertPopup = function () {
            modalController.alertModal
                            .clearModal()
                            .setTitle('กรุณาปักหมุดแผนที่')
                            .setMsg('สำหรับแจ้งเคลมให้ตรงกับสถานที่นัดหมาย')
                            .show()
            modalController.alertModal.onClickOk(() => {
                locationUpdated()
            })
        }

        onMounted(() => {
            loadingModal.show()

            getInfo().then(() => {
                return mapService.getCurrentLocation().then(() => {
                    return mapService.initMaps()
                })
            }).then(() => {
                mapService.pinCurrent(null, IconMapPinNormal, null, null, true)
                mapService.getAddressByGeolocation(mapService.latLng.value).then((addr) => {
                    console.log(addr)
                    placeAddress.value = addr
                })
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                isPageLoaded.value = true
                loadingModal.hide()

                alertPopup()
            })
        })

        return {
            isPageLoaded,
            elemMaps,
            policyDetail,
            customerInfo,
            currentTime,
            onSubmitForm,
            isDisable,
        }
    },
})
</script>

<style lang="scss" scoped>
.map-area {
    height: 190px;
    @apply flex-none bg-a-gray-d0d0ce relative;
}
</style>
